import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

// Import utilities
import { useOperators } from 'components/utilities';

// Import variables
import { TV_PATHS } from 'components/routes/tv_routes/paths';

const { MAIN } = TV_PATHS;

const ProtectedUserLogged = ({ isLogged, component: Component }) => {
	const { isOperator } = useOperators();
	const { state } = useLocation();
	const defaultRedirectUrl = isOperator ? MAIN : '/';
	const redirectURL = state?.redirectTo ?? defaultRedirectUrl;
	return (
		<Route
			render={(props) =>
				isLogged ? <Redirect to={redirectURL} /> : <Component {...props} />
			}
		/>
	);
};

const mapStateToProps = ({ auth }) => {
	return {
		isLogged: auth.isLogged
	};
};

export default connect(mapStateToProps)(ProtectedUserLogged);
